import Vue from 'vue';
import Router from 'vue-router';
import { OktaAuth } from '@okta/okta-auth-js';
import OktaVue from '@okta/okta-vue';
import { LoginCallback } from '@okta/okta-vue';
import MainPage from '../components/Universal';
const { VUE_APP_CLIENT_ID, VUE_APP_ISSUER } = process.env;

const oktaAuth = new OktaAuth({
  issuer: VUE_APP_ISSUER,
  clientId: VUE_APP_CLIENT_ID,
  redirectUri: `/login/callback`,
  scopes: ['openid', 'profile', 'email']
});

Vue.use(Router);
Vue.use(OktaVue, { oktaAuth });

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/login/callback',
      component: LoginCallback,
      name: 'redirect',
    },
    {
      path: '/',
      component: MainPage,
      name: 'MainPage',
      meta: {
        requiresAuth: true
      },
    },
    {
      path: 'https://www.just-eat.co.uk/deals/pr-decision-tree/',
      component: MainPage,
      name: 'MainPage',
      meta: {
        requiresAuth: true
      },
    }
  ]
});
